import Book from "../../components/Book";

const AppointmentBook = () => {
  return (
    <Book />
  );
};

export default AppointmentBook;
